"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLoginInput = instanceOfLoginInput;
exports.LoginInputFromJSON = LoginInputFromJSON;
exports.LoginInputFromJSONTyped = LoginInputFromJSONTyped;
exports.LoginInputToJSON = LoginInputToJSON;
/**
 * Check if a given object implements the LoginInput interface.
 */
function instanceOfLoginInput(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
function LoginInputFromJSON(json) {
    return LoginInputFromJSONTyped(json, false);
}
function LoginInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'password': json['password'],
    };
}
function LoginInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'password': value['password'],
    };
}
